// signInProvider — the identity providers the sign-in page offers next to the
// email path ("Continue with Google / Microsoft"). Each starts the same Auth0
// sign-in, sent straight to that provider instead of Auth0's own page.
//
// A closed set, parsed at BOTH boundaries: the client builds the request from
// it, and the server's login route re-parses the untrusted query value. Only a
// listed provider is ever passed on; anything else reads as "none" (the plain
// Auth0 sign-in), never an error. The provider-specific names (Auth0's
// connection ids) belong to the server's Auth0 adapter, not here. Pure: no
// I/O. Exposed as `@bilda/app/signInProvider`.
export { parseSignInProvider, signInProviderParam, signInProviders };
const signInProviderParam = "provider";
// Display order on the sign-in page (a-02: Google, then Microsoft).
const signInProviders = ["google", "microsoft"];
const parseSignInProvider = (raw) => signInProviders.find((provider) => provider === raw);
//# sourceMappingURL=signInProvider.js.map